/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Cycle_To_SystemInputs */

const cs_theme_cycle_to_system = /** @type {(inputs: Theme_Cycle_To_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tmavý režim — přepnout na systémový`)
};

const en_theme_cycle_to_system = /** @type {(inputs: Theme_Cycle_To_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark mode — switch to system`)
};

/**
* | output |
* | --- |
* | "Dark mode — switch to system" |
*
* @param {Theme_Cycle_To_SystemInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const theme_cycle_to_system = /** @type {((inputs?: Theme_Cycle_To_SystemInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Cycle_To_SystemInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_theme_cycle_to_system(inputs)
	return cs_theme_cycle_to_system(inputs)
});